import { List } from "antd";
import SelectInput from "top-component-library/form-inputs/SelectInput";

import AlertCard from "./AlertCard";
import { StepContainer } from "./styles";

// The custom-alert builder: an "Add an alert" dropdown plus the list of configured alert cards.
const CustomAlertsStep = ({
  availableAlerts,
  alertsToAdd,
  possibleStations,
  onAddAlert,
  onChangeOption,
  onRemoveAlert,
}) => (
  <StepContainer>
    <div>
      <p>
        Step 2: Set up the Alerts you want to send. To set up a new Alert, click the dropdown and select an Alert type.{" "}
        <br />
        By default, each new Alert will apply to all stations. To set the alert to a specific station, click the x next
        to 'All Stations' to clear the box. <br />
        When you click into that box again, you'll be able to select individual stations.
      </p>
    </div>
    Add an alert
    <SelectInput id="addAlerts" options={availableAlerts} onChange={(alertType) => onAddAlert(alertType)} />
    <List>
      {alertsToAdd.map((alert, i) => (
        <AlertCard
          key={i}
          alert={alert}
          index={i}
          possibleStations={possibleStations}
          onChangeOption={onChangeOption}
          onRemove={onRemoveAlert}
        />
      ))}
    </List>
  </StepContainer>
);

export default CustomAlertsStep;
